import * as React from 'react'

import FeatureContainer from '../../containers/feature'
import SearchResultsBody from '../../pages/search/result/searchResultBody'
import V0SearchResults from '../../v0/pages/search/result/searchResultBody'

import { ICommonLocation } from '../../../common/utils/location/types'
import { IItem } from '../../../typings/searchResults'

import * as styles from './itemsGridWithSidebar.module.css'

interface IProps {
  items: IItem[]
  location: ICommonLocation
  sidebar: React.ReactNode
}

const ItemsGridWithSidebar = ({ items, location, sidebar }: IProps) => {
  return (
    <div className={styles.root}>
      <div className={styles.grid}>
        <FeatureContainer name="!v0-featured-page">
          <SearchResultsBody
            location={location}
            matches={items}
            viewType="grid"
          />
        </FeatureContainer>
        <FeatureContainer name="v0-featured-page">
          <div className={styles.v0Results}>
            <V0SearchResults
              location={location}
              matches={items}
              viewType="grid"
            />
          </div>
        </FeatureContainer>
      </div>
      <div className={styles.sidebar}>{sidebar}</div>
    </div>
  )
}

export default ItemsGridWithSidebar
